module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Volume-full-d86f02c61e38a8560a7d8ff17063a33a.svg";